interface ToggleButtonProps {
  enabled: boolean;
  onClick: () => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function ToggleButton({ enabled, onClick, disabled = false, size = 'md' }: ToggleButtonProps) {
  const sizes = {
    sm: {
      container: 'h-5 w-9',
      ball: 'h-3 w-3',
      translate: enabled ? 'translate-x-5' : 'translate-x-1'
    },
    md: {
      container: 'h-6 w-11',
      ball: 'h-4 w-4',
      translate: enabled ? 'translate-x-6' : 'translate-x-1'
    },
    lg: {
      container: 'h-8 w-14',
      ball: 'h-6 w-6',
      translate: enabled ? 'translate-x-7' : 'translate-x-1'
    }
  };

  const currentSize = sizes[size];

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`relative inline-flex ${currentSize.container} items-center rounded-full transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:cursor-not-allowed ${
        enabled
          ? 'bg-green-600 dark:bg-green-500 shadow-sm'
          : 'bg-gray-300 dark:bg-gray-600'
      } ${disabled ? 'opacity-50' : 'hover:shadow-md'}`}
    >
      <span
        className={`inline-block ${currentSize.ball} transform rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out ${currentSize.translate}`}
      />
    </button>
  );
}
